import qrcode from "qrcode-generator";
import { useMemo } from "react";

const QUIET = 4; // modules of white margin; scanners need it

/**
 * Draws `value` as an SVG QR code (qrcode-generator 2.0.4, pinned). One <path>, no innerHTML, no data URL: the strict CSP
 * and the wall kiosk's secret both stay out of any markup besides the code itself.
 */
export function QrCode({ value, label, className }: { value: string; label: string; className?: string }) {
  const { path, size } = useMemo(() => {
    const qr = qrcode(0, "M");
    qr.addData(value);
    qr.make();
    const n = qr.getModuleCount();
    let d = "";
    for (let r = 0; r < n; r++) for (let c = 0; c < n; c++) if (qr.isDark(r, c)) d += `M${c + QUIET} ${r + QUIET}h1v1h-1z`;
    return { path: d, size: n + QUIET * 2 };
  }, [value]);
  return (
    <svg className={className} viewBox={`0 0 ${size} ${size}`} role="img" aria-label={label} shapeRendering="crispEdges" data-qr={value}>
      <rect width={size} height={size} fill="var(--color-surface-card)" />
      <path d={path} fill="var(--color-text-primary)" />
    </svg>
  );
}
